import { useEffect, useState } from "react";

type Language = "en" | "de";

export function useLanguage(): Language {
  const [language, setLanguage] = useState<Language>(() => {
    // Check localStorage first for persisted preference
    const stored = localStorage.getItem("preferred-language");
    if (stored === "en" || stored === "de") {
      return stored;
    }

    // Detect from browser
    const browserLang = navigator.language || navigator.languages?.[0] || "en";
    return browserLang.toLowerCase().startsWith("de") ? "de" : "en";
  });

  useEffect(() => {
    // Persist the language preference
    localStorage.setItem("preferred-language", language);
    
    // Update html lang attribute
    document.documentElement.lang = language;
  }, [language]);

  return language;
}


